function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import React, { useEffect } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import ArrowIcon from 'svg/ap/arrow.svg';
import SessionStorage from 'libs/SessionStorage';
import messages from '../../../../messages';
import styles from './BackButton.pcss';
const BackButton = ()=>{
    useStyles(styles);
    const blsReturnUrl = SessionStorage.getItem('GCOReturnUrl');
    useEffect(()=>()=>{
            SessionStorage.removeItem('GCOReturnUrl');
        }, []);
    if (!blsReturnUrl) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.backButton,
        children: /*#__PURE__*/ _jsxs("a", {
            href: blsReturnUrl,
            className: styles.backButton__link,
            children: [
                /*#__PURE__*/ _jsx(ArrowIcon, {
                    className: styles.backButton__arrow
                }),
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.labels.backToGCO))
            ]
        })
    });
};
export default BackButton;
